import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule  } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './components/home.component';
import { WhatWeOfferComponent } from './components/what-we-offer.component';
import { ProfileComponent } from './candidate/profile/profile.component';
import { SignupComponent } from './candidate/signup/signup.component';
import { loginComponent } from './candidate/login/login.component';
import { CanidadateCVComponent } from './candidate/cv/candidate-cv.component';
import { VacancyComponent } from './vacancies/vacancy/vacancy.component';
import { VacanciesComponent } from './vacancies/vacancies/vacancies.component';

const routes: Routes =[
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: 'home',             component: HomeComponent },
    { path: 'what-we-offer',             component: WhatWeOfferComponent },
    { path: 'user-profile/vacancies',     component: ProfileComponent },
    { path: 'cv',     component: CanidadateCVComponent },
    { path: 'user-profile',     component: ProfileComponent },
    { path: 'signup',           component: SignupComponent },
    { path: 'login',          component: loginComponent },
    { path: 'vacancy/:id',      component: VacancyComponent },
    { path: 'vacancies',      component: VacanciesComponent }
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes,{
      
    })
  ],
  exports: [
  ],
})
export class AppRoutingModule { }
